import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LiveBackground from "../../liveBackground/LiveBackground";
import { mapTypeLabel } from "../../../constant/General";
import ResultTCDay from "./ResultTCDay";
import { getDateTime } from "../../../utility/dateUtils";
import Welcome from "../../live2/Welcome";
import { drawingV2 } from "../../../constant/initDrawing";
import LayoutWrapper from "../../live2/tc/LayoutWrapper";
import SelectBGWrapper from "../../live2/tc/SelectBGWrapper";
import ResultTCNight from "./ResultTCNight";




const Live3TCWrapper = ({ config, socket }) => {
    const { type, subFixType = "" } = config;
    const location = useLocation();
    const navigate = useNavigate();
    const isV4 = location.pathname.startsWith("/live-v4/");
    const [currentResult, setCurrentResult] = useState(drawingV2);
    const [result, setResult] = useState(drawingV2);
    const subTypes = subFixType ? `${type}s_${subFixType}_result` : `${type}s_result`


    useEffect(() => {
        socket.on(subTypes, (payload) => {
            setCurrentResult(payload);
            if (result.results.length === 0 || result.isInited) {
                setResult(payload)
            }
        });


        return () => {
            socket.off(subTypes);
        }
    }, [socket, type, subTypes, result]);

    const onStartDraw = (result) => {
        setResult(result)
    }

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw} />

    return <LiveBackground result={result} variant={isV4 ? "v4" : undefined}
        preserveInnerBackgrounds={isV4} className="d-flex justify-content-center overflow-hidden mt-2">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(isV4 ? "/live-v4" : "/live-v3")}
        >
            Back
        </button>
        <div>
            {!isV4 && <div className="d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    {mapTypeLabel[config.type]}
                </span> {getDateTime(result?.drawAt)}
            </div>}
            <LayoutWrapper>
                {!result?.isNight ?
                    <SelectBGWrapper type={type} shift="day" hideControls={isV4}>
                        <ResultTCDay
                            result={result}
                            setResult={setResult}
                            currentResult={currentResult}
                            config={config} />
                    </SelectBGWrapper> :
                    <SelectBGWrapper type={type} shift="ng" hideControls={isV4}>
                        <ResultTCNight
                            result={result}
                            currentResult={currentResult}
                            setResult={setResult}
                            config={config} />
                    </SelectBGWrapper>
                }
            </LayoutWrapper>

        </div>
    </LiveBackground>

};


export default Live3TCWrapper;
